import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import queryString from 'query-string'

import { getOptional } from 'actions/Dashboard/TrainingDetail/optional'
import { loadingStart, loadingEnd } from 'actions/loading'

import FiltersUrl from 'components/FiltersUrl'
import PaginationUrl from 'components/PaginationUrl'
import Table from 'components/Table'
import filtersOptional from 'config/Dashboard/Filters/filtersOptional'
import columnsOptional from 'config/Dashboard/Columns/columnsOptional'

export default function Optional() {
  const dispatch = useDispatch()
  const dataOptional = useSelector((state) => state.optional)
  const location = useLocation()
  const query = queryString.parse(location.search)
  useEffect(() => {
    filtersOptional
      .filter((x) => x.isMulti)
      .forEach((filterMulti) => {
        if (query[filterMulti.name] && !(query[filterMulti.name] instanceof Array)) {
          query[filterMulti.name] = [query[filterMulti.name]]
        }
      })
    dispatch(loadingStart())
    dispatch(getOptional(query)).then(() => {
      dispatch(loadingEnd())
    })
  }, [location.search])
  return (
    <>
      <FiltersUrl filters={filtersOptional} isLoading={dataOptional.isLoading} />
      <Table columns={columnsOptional} data={dataOptional.values} />
      {dataOptional.values.length ? (
        <PaginationUrl total={dataOptional.total} size={10}></PaginationUrl>
      ) : (
        ''
      )}
    </>
  )
}
